import {
  AUTH_DATA_NAME,
  AUTH_MODAL_NAME,
  LOGIN_USER_NAME,
  REFRESH_USER_NAME,
  RESET_PASSWORD_NAME,
  SIGNUP_USER_NAME,
} from '../redux/state';


/**
 *
 * CODE_TAG[Global-state-shape-aware]
 * @param rootState
 * @return {*}
 */
export function getAuthState(rootState) {
  return rootState.auth;
}

export function getAuthDataState(rootState) {
  return rootState.auth[AUTH_DATA_NAME];
}

export function getUserId(rootState) {
  return getAuthDataState(rootState).userId;
}

export function getIsAuthenticated(rootState) {
  return getAuthDataState(rootState).isAuthenticated;
}

export function getApiToken(rootState) {
  return getAuthDataState(rootState).apiToken;
}

export function getFirebaseToken(rootState) {
  return getAuthDataState(rootState).firebaseToken;
}

export function getAuthProfile(rootState) {
  return getAuthDataState(rootState).profile;
}

export function getAuthModal(rootState) {
  return getAuthState(rootState)[AUTH_MODAL_NAME];
}

export function getLoginUser(rootState) {
  return getAuthState(rootState)[LOGIN_USER_NAME];
}

export function getRefreshUser(rootState) {
  return getAuthState(rootState)[REFRESH_USER_NAME];
}

export function getResetPassword(rootState) {
  return getAuthState(rootState)[RESET_PASSWORD_NAME];
}

export function getSignupUser(rootState) {
  return getAuthState(rootState)[SIGNUP_USER_NAME];
}



// WEBPACK FOOTER //
// ./src/js/auth/reducers/state.js